/**
 * 마크다운 본문을 한 줄 미리보기용 평문으로 줄인다.
 *
 * 리스트/위젯의 잘린 미리보기에서 `##`, `**`, `- ` 같은 마크다운 기호가 그대로
 * 노출되면 지저분하므로, 서식 기호만 제거해 읽을 수 있는 텍스트로 만든다.
 * 보안 목적이 아니라 표시용이라 가벼운 정규식으로 충분하다(렌더가 아니므로 XSS 무관).
 */
export function markdownToPlainText(md: string | null | undefined): string {
  if (!md) return '';
  return md
    .replace(/```[\s\S]*?```/g, ' ') // 코드 블록
    .replace(/`([^`]+)`/g, '$1') // 인라인 코드
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // 이미지
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1') // 링크 → 텍스트만
    .replace(/^\s{0,3}#{1,6}\s+/gm, '') // 헤더 기호
    .replace(/^\s{0,3}>\s?/gm, '') // 인용
    .replace(/^\s*([-*+]|\d+\.)\s+/gm, '') // 목록 마커
    .replace(/(\*\*|__)(.*?)\1/g, '$2') // 굵게
    .replace(/(\*|_)(.*?)\1/g, '$2') // 기울임
    .replace(/~~(.*?)~~/g, '$1') // 취소선
    .replace(/\s*\n+\s*/g, ' ') // 줄바꿈 → 공백
    .replace(/\s{2,}/g, ' ')
    .trim();
}
